// @flow
import { createAction } from 'redux-actions';

type SearchPayload = {
  query: { [string]: string },
  method: Function,
  page: number,
  label: string,
};

export const requestSearchResults = createAction(
  '@search/request',
  (payload: SearchPayload) => payload
);

export const navigateSearchResults = createAction(
  '@search/navigate',
  (payload: SearchPayload) => payload
);

export const receiveSearchResults = createAction(
  '@search/receive',
  (results: Array<UgcId>, totalPages?: number) => ({ items: results, totalPages })
);

type FormPayload = {
  helper: *,
  value: *,
};

export const initForm = createAction(
  '@search/form/init',
  (payload: FormPayload) => payload
);

export const updateForm = createAction(
  '@search/form/update',
  (payload: FormPayload) => payload
);

export const clearSearch = createAction('@search/clear');

export const submitSearch = createAction(
  '@search/submit',
  (query: { [string]: string }) => query
);



// WEBPACK FOOTER //
// ./src/containers/search/searchActions.js